module.exports = __webpack_public_path__ + "img/VB.26ae896f.png";